import React, { Component } from 'react';

export default class WebSubsection extends Component {

    constructor(props) {
        super(props);

    }

    render() {

        return (
            //row when tablet or pc, column when phone 
            <div class="row">
                <div class="col-sm-4">
                    <img className='roomtype-image' src={this.props.webSubsection.image.url} alt={this.props.webSubsection.image.url} />
                </div>
                <div class="col-sm-8">
                    <pre>{this.props.webSubsection.text}</pre>
                </div>
            </div>
            
        );
    }

}